import { Type } from "@sinclair/typebox";
import { quoteWorkingPortionInputSchema } from "./quote-working-portion.js";
export const quoteScopeInputSchema = Type.Object({
    members: Type.Array(Type.Object({
        workItemId: Type.String({ format: "uuid" }),
        expectedVersion: Type.Integer({ minimum: 1 }),
        workingPortion: Type.Optional(quoteWorkingPortionInputSchema)
    }, { additionalProperties: false }), { minItems: 1, maxItems: 5 }),
    partiesConfirmed: Type.Literal(true)
}, { additionalProperties: false });
//# sourceMappingURL=quote-scope.js.map